window.localUsabilityClickElements = {
  'button[data-target="#header-main-navi-nav"][aria-expanded="false"]': {
    //Menü-Button wird geöffnet
    'type': 'action',
    'click': 'Das Menü wurde geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Menü wird geöffnet'
  },
  'button[data-target="#header-main-navi-nav"][aria-expanded="true"]': {
    //Menü-Button wird geschlossen
    'type': 'action',
    'click': 'Das Menü wurde geschlossen',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Menü wird geschlossen'
  },
  '#header-main-navi-nav a:not([rel*="external"])': {
    //Interner Link im Menü
    'type': 'navigation',
    'click': 'Navigation via Menüpunkt "{INNER-TEXT}"',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#header-main-navi-nav a[rel*="external"]': {
    //Externer Link im Menü
    'type': 'exit',
    'click': 'Navigation via Menüpunkt "{INNER-TEXT}"',
    'click_chapter1': 'Menü',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#header button.btn-search[data-toggle="dropdown"]': {
    //Suche-Button
    'type': 'action',
    'click': 'Suche im Header wird geöffnet',
    'click_chapter1': 'Menü',
    'click_chapter3': 'Suche wird geöffnet'
  },
  '.more-linking a[rel*="external"]': {
    //Externer Link "Mehr zum Thema"
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Block "Mehr"',
    'click_chapter3': '{ZIEL-URL}'
  },
  '#footer a[rel*="external"]': {
    //Externer Link im Footer
    'type': 'exit',
    'click': 'Navigation via Link im Footer zu "{INNER-TEXT}"',
    'click_chapter1': 'Footer',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .inline-link[rel*="external"]': {
    //Externer Link im Copytext
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link im Copytext',
    'click_chapter3': '{ZIEL-URL}'
  },
  '.bodytext .linkliste a[rel*="external"]': {
    //Externer Link in Multibox
    'type': 'exit',
    'click': 'Navigation via Text-Link mit Inhalt "{INNER-TEXT}"',
    'click_chapter1': 'Text-Link in Multibox',
    'click_chapter3': '{ZIEL-URL}'
  },
}
